import { useState, useCallback } from 'react';

import useIsScreenSize from 'js/hooks/use-is-screen-size';
import useOnFocusInsideChange from 'js/hooks/use-on-focus-inside-change';

interface UseTooltipReturn {
  ref: React.RefObject<HTMLElement>;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
  toggleTabTooltip: (open: boolean) => void;
  showTabTooltip: boolean;
  showTooltip: boolean;
}

const useTooltip = (toggleFocusListener?: boolean): UseTooltipReturn => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [showTabTooltip, setShowTabTooltip] = useState<boolean>(false);

  const isMediumScreen = useIsScreenSize('md');

  const closeTooltip = useCallback(() => {
    setShowTabTooltip(false);
  }, []);

  const toggleTabTooltip = useCallback(
    (open: boolean) => {
      if (open) {
        document.addEventListener('mousemove', closeTooltip);
        setShowTooltip(false);
        setShowTabTooltip(true);
      } else {
        setShowTabTooltip(false);
      }
    },
    [closeTooltip]
  );

  const ref = useOnFocusInsideChange(toggleTabTooltip, toggleFocusListener);

  const openTooltip = useCallback(() => {
    setShowTooltip(true);
    setShowTabTooltip(false);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowTooltip(false);
  }, []);

  return {
    ref,
    handleMouseEnter: openTooltip,
    handleMouseLeave,
    toggleTabTooltip,
    showTabTooltip: (isMediumScreen && showTabTooltip) ?? false,
    showTooltip: (isMediumScreen && showTooltip) ?? false
  };
};

export default useTooltip;
